import React,{useState, useEffect, useContext} from 'react'
import ContextManager from "./context-manager";


export default function ItemText({data}) {
    const {handleSelect} = useContext(ContextManager);

    // 默认选择第一个
    const seleced = data.values[0]
    const [activeId, setActiveId] = useState(seleced.id)
    useEffect(() => {
        handleSelect('price', data.id, seleced)
    }, [])

    const renderInfo = item => {
        if (item.type === 'IMAGE') {
            return <img src={item.smallImage} />
        }else if(item.type === 'TEXT'){
            return <span>{item.name}</span>
        }else{
            return <span className="color"></span>
        }
    }

    return ( 
        <div className="sku-item">
            <label>{data.name}:</label>
            <div className="item-size">
                {data.values.map(sku => <a href="#" className={activeId === sku.id ? 'sku-actived' : ''} key={sku.id} style={{
                backgroundColor: sku.color || ''
            }} onClick={e => {
                e.preventDefault();
                setActiveId(sku.id)
                handleSelect('price', data.id, sku)
            }}>{renderInfo(sku)}</a>)}
            </div>
        </div>
    )
}